import {
  Component,
  OnDestroy,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyService, DocumentService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/contractor/services';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';
import { AolService } from '../../services/aol';
import { type } from 'os';
import { LinkDocumentModal } from '../link-document-type-modal/link-document-type-modal.component';
import { ActivatedRoute } from '@angular/router';
import { AppFilter } from '@app/shared/models';
import { EditSharesModal } from '../edit-shares/edit-shares-component';

interface INewDirectorModalContext {
  data?: any;
  title?: string;
  isEdit?: boolean;
}
interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
@Component({
  selector: 'app-new-company-modal',
  templateUrl: './new-company-modal.component.html',
  styleUrls: ['./new-company-modal.component.scss'],
})
export class NewCompanyModalComponent implements OnInit, OnDestroy {
  pending: boolean = false;
  companyDirectorForm: FormGroup;
  formSubmitAttempt: boolean;
  countries: Array<any> = [];
  typeId: string = 'Individual';
  typeName;
  affiliateTypeId;
  success: any;
  error: any;
  eRadio: any = 'new';
  firstPage: boolean = true;
  secondPage: boolean = false;
  checkbox: boolean = false;
  filter: AppFilter = new AppFilter();
  organizationId: string;
  companyAffiliateTypes!: any[];
  allAffiliateTypes!: any[];
  selectedFilePhoto: File | null = null;
  fileNamePhoto: string = '';
  imageUrl: string | ArrayBuffer | null = '';
  companyType = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor?.companyType?.optionId;
  companyDirectors: any[] = [];
  baseUrl = environment.API_SERVER;
  uploadFormData: any;
  replyForm: FormGroup;
  resultToBeAdded;
  typeStructure;
  organization;
  companyDirector;
  shareHoldingAmount;
  usePercentage: boolean = false;
  showCapital: boolean = false;
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<INewDirectorModalContext, void, void>,
    private documentSvc: DocumentService,
    private companyOwnershipService: CompanyOwnershipService,
    private AolService: AolService
  ) {
    this.countries = this.modal.context.data.countries;
    this.usePercentage = this.modal.context.data?.usePercentage;
    this.typeStructure = this.modal.context.data.item;
    this.affiliateTypeId = this.modal.context.data.affiliateTypeId;
    this.shareHoldingAmount = this.modal.context.data.shareHoldingAmount;
    this.typeName = this.modal.context.data.affiliateTypeName;
    this.organization = JSON.parse(window.localStorage.getItem('user'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 100 });
    this.companyDirectorForm = fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      address: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
      middleName: [''],
      shareholderType: [''],
      companyName: [''],
      companyRegNumber: [''],
      gender: ['', Validators.required],
      nationalityId: ['', Validators.required],
      countryOfOriginId: ['', Validators.required],
      nationalIdNumber: ['', Validators.required],
      organizationOwnershipTypeId: [''],
      organizationOwnershipId: [''],
      shareholding: [0, Validators.required],
      actionType: [''],
      shareCapital: [this.shareHoldingAmount],
      shareAllocated: [''],
    });
    this.replyForm = fb.group({
      documentTypeId: ['CHANGE_REQUEST_DOCUMENT', Validators.required],
      documentName: ['PROFILE_PHOTO', Validators.required],
      document: ['', Validators.required],
      attachment: [true],
      documentDescription: ['string'],
    });
    if (this.modal.context.isEdit) {
      this.secondPage = true;
      this.firstPage = false;
      this.companyDirector = modal.context.data.director;

      this.companyDirectorForm.patchValue(this.companyDirector);
      this.companyDirectorForm
        .get('shareAllocated')
        .setValue(
          (modal.context.data.director.shareholding / 100) *
            modal.context.data.shareHoldingAmount
        );
    }
    this.companyDirectorForm
      .get('shareAllocated')
      .valueChanges.subscribe((value) => {
        this.calculateShareholding(value);
      });
    this.companyDirectorForm
      .get('shareCapital')
      .valueChanges.subscribe((value) => {
        this.calculateShareholding(value);
      });
  }
  calculateShareholding(shareAllocated: string) {
    const numericShareAllocated = parseFloat(shareAllocated.replace(/,/g, ''));
    if (numericShareAllocated && this.shareHoldingAmount) {
      const shareholding =
        (numericShareAllocated / this.shareHoldingAmount) * 100;
      this.companyDirectorForm.get('shareholding').setValue(shareholding);
    } else {
      this.companyDirectorForm.get('shareholding').setValue(0);
    }
  }
  editShares() {
    this.modalService
      .open(
        new EditSharesModal(
          'Edit Total Share Capital',
          this.shareHoldingAmount,
          ModalSize.Mini
        )
      )
      .onApprove((payload) => {
        this.shareHoldingAmount = payload;
        this.companyDirectorForm.get('shareCapital').setValue(payload);
      })
      .onDeny(() => {});
  }
  onFileChangeData(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    if (this.isFileTypeAllowed(files[0])) {
      this.selectedFilePhoto = files[0];
      this.fileNamePhoto = this.selectedFilePhoto['name'];
      this.previewImage(this.selectedFilePhoto);
    } else {
      this.error =
        'Invalid file type. Please select a .jpg, .jpeg, or .png file.';
      return;
    }
  }
  getDocumentPath(data) {
    this.pending = true;
    this.AolService.getDocument({ documentId: data }).subscribe(
      (res: any) => {
        this.pending = false;
        this.fileNamePhoto = res.documentPath.split('______')[1];
        this.imageUrl = `${this.baseUrl}/public/image/?media=${res.documentPath}`;
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }
  isFileTypeAllowed(file: File): boolean {
    const allowedTypes = ['.jpg', '.jpeg', '.png'];
    const fileType = '.' + file.name.split('.').pop();
    return allowedTypes.includes(fileType.toLowerCase());
  }
  previewImage(file: File) {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageUrl = e.target?.result;
    };
    reader.readAsDataURL(file);
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
    this.getAffiliateTypes(this.companyType);
  }
  getAffiliateTypes(companyTypeId: string) {
    this.pending = true;
    if (companyTypeId == 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId: companyTypeId })
      .subscribe(
        (res: any[]) => {
          this.companyAffiliateTypes = res;
          this.getAllAfiliateTypes();
        },
        (error) => {
          console.log(error);
          this.pending = false;
        }
      );
  }

  getAllAfiliateTypes() {
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res;
        let t = setInterval(() => {
          if (this.pending == false) {
            clearInterval(t);
          }
          if (this.companyAffiliateTypes) {
            this.companyAffiliateTypes.forEach((companyAffiliateType) => {
              this.allAffiliateTypes.every((affiliateType) => {
                if (
                  companyAffiliateType.ownershipType == affiliateType.optionName
                ) {
                  companyAffiliateType.ownershipTypeId = affiliateType.optionId;
                  return false;
                }
                return true;
              });
            });
            this.companyAffiliateTypes = this.companyAffiliateTypes.filter(
              (type) => type.ownershipTypeId !== this.affiliateTypeId
            );
            this.companyAffiliateTypes.map((item) => {
              this.getPage(1, item.ownershipTypeId);
            });
            clearInterval(t);
          }
        }, 200);
      },
      (error) => {
        this.pending = false;
      }
    );
  }
  getPage(page, ownershipType) {
    this.filter.page = page;
    this.pending = true;
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        ownershipType: ownershipType,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.companyDirectors = this.companyDirectors.concat(res.rows);
          if (
            this.modal.context.isEdit &&
            this.modal.context.data.director.photographDocumentId
          ) {
            this.getDocumentPath(
              this.modal.context.data.director.photographDocumentId
            );
          } else {
            this.pending = false;
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }
  submit() {
    if (this.eRadio === 'existing' && !this.secondPage) {
      this.existingSubmission();
    }
    this.secondPage = true;
    this.firstPage = false;
    if (!this.usePercentage && this.affiliateTypeId === 'shareholder_type') {
      if (
        this.shareHoldingAmount <
          Number(this.companyDirectorForm.value.shareAllocated) ||
        this.shareHoldingAmount === 0 ||
        Number(this.companyDirectorForm.value.shareholding) > 100
      ) {
        this.showCapital = true;
        return;
      }
    }
    this.newSubmission();
    return;
  }
  newSubmission() {
    if (this.selectedFilePhoto) {
      if (!this.getFileSizePhotograph(this.selectedFilePhoto.size)) {
        this.error = `File (${this.selectedFilePhoto.name}) size is too large, Maximum file size is 1MB`;
        return;
      }
      this.pending = true;
      let data: any = this.replyForm.value;
      const formData: FormData = new FormData();
      formData.append(
        'file',
        this.selectedFilePhoto,
        this.selectedFilePhoto.name
      );
      let payload: any = { formValue: data, formData: formData };
      this.uploadFormData = payload['formData'];
      const values = payload['formValue'];
      const jsonse = JSON.stringify(values);
      const blob = new Blob([jsonse], { type: 'application/json' });
      this.uploadFormData.append('data', blob);
      this.onUploadFilePhoto(this.uploadFormData);
    } else if ((this.modal.context.isEdit && this, this.imageUrl)) {
      this.saveAction(this.modal.context.data.director);
    } else {
      this.error = `Please Upload a Profile Photo`;
      return;
    }
  }
  existingSubmission() {
    this.resultToBeAdded = this.companyDirectors.filter(
      (item) => item.checkbox
    );
    if (this.resultToBeAdded.length > 0) {
      this.resultToBeAdded.map((item) => {
        item.actionType = 'ADD';
      });
      this.pending = true;
      this.success = `Record ${
        this.modal.context.isEdit ? 'Updated' : 'Added'
      }`;
      setTimeout(() => {
        this.modal.approve(this.resultToBeAdded);
        return;
      }, 3000);
    } else {
      this.error = `Please Select an Existing structure`;
      return;
    }
  }
  getFileSizePhotograph(fileInput: number) {
    if (fileInput) {
      const fileSizeBytes = fileInput;
      const fileSizeKB = fileSizeBytes / 1024;
      const fileSizeMB = fileSizeKB / 1024;
      if (fileSizeMB > 1) {
        return false;
      } else {
        return true;
      }
    }
  }
  onUploadFilePhoto(data) {
    this.success = null;
    this.error = null;
    this.pending = true;
    this.documentSvc
      .uploadDocument({ organizationId: this.organizationId, body: data })
      .subscribe(
        (res: any) => {
          this.saveAction(res);
        },
        (error) => {
          this.pending = false;
          this.error = 'Error while uploading Documents Retry';
        }
      );
  }
  saveAction(result) {
    this.resultToBeAdded = [];
    console.log(this.companyDirectorForm.value);
    if (this.companyDirectorForm.value.organizationOwnershipId) {
      this.companyDirectorForm.value.actionType = this.modal.context.isEdit
        ? 'UPDATE'
        : 'ADD';
    } else {
      this.companyDirectorForm.value.actionType = 'ADD';
    }
    this.companyDirectorForm.value.photographDocumentId = result.documentId
      ? result.documentId
      : result.photographDocumentId;
    this.companyDirectorForm.value.photographDocumentPath = result.documentPath
      ? result.documentPath
      : result.photographDocumentPath;
    (this.companyDirectorForm.value.createdBy = JSON.stringify({
      name: this.organization.firstName + ' ' + this.organization.lastName,
      username: this.organization.username,
      appUserId: this.organization.appUserId,
      organizationId: this.organization.organizationId.organizationId,
      organizationName: this.organization.organizationId.organizationShortName,
    })),
      (this.companyDirectorForm.value.dateCreated = new Date().toISOString()),
      this.resultToBeAdded.push(this.companyDirectorForm.value);
    this.success = `Record ${this.modal.context.isEdit ? 'Updated' : 'Added'}`;
    setTimeout(() => {
      this.modal.approve(this.resultToBeAdded);
      return;
    }, 3000);
  }
  goBack() {
    this.secondPage = false;
    this.firstPage = true;
    this.eRadio = 'new';
  }
  isFieldValid(field: string) {
    return (
      (!this.companyDirectorForm.get(field).valid &&
        this.companyDirectorForm.get(field).touched) ||
      (this.companyDirectorForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }
  onBoxChecked(value) {
    if (value?.checkbox) {
    } else {
    }
  }
  deleteImage(event: Event) {
    event.stopPropagation();
    this.imageUrl = null;
    this.fileNamePhoto = null;
  }
}

export class NewCompanyModal extends ComponentModalConfig<
  INewDirectorModalContext,
  void,
  void
> {
  constructor(
    title: string,
    data: any,
    isEdit: boolean,
    size: ModalSize = ModalSize.Mini
  ) {
    super(NewCompanyModalComponent, { title, data, isEdit });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
